import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import './TablePage.less';
import ButtonML from '@/components/button_ml/ButtonML';
import dayjs from 'dayjs';
import React from 'react';
import { message } from 'antd';
import Loading from '@/components/Loading';
import { useSelector, useDispatch } from 'dva';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTrigger } from '@/utils/comHook.js';

const OutputTabel = (props) => {
  //控制弹框的开关
  const deleteTrigger = useTrigger();
  const dispatch = useDispatch();
  const { editTabel, fetchData, editable } = props || {};
  // const [delLoading, setDelLoading] = useState(false);
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['condition/getOutputList'];
  const delLoading = loadingEffect.effects['condition/getOutputList'];
  let data = useSelector((state) => state.condition.getOutputList);
  const { code } = data || {};
  if (code) {
    data = [];
  }
  //删除规则
  const deleteRuleChange = (values) => {
    // setDelLoading(true);
    dispatch({
      type: 'condition/deleteOutputList',
      payload: {
        values: {
          ...values,
        },
      },
      callback: () => {
        // setDelLoading(false);
        message.success('删除成功');
        fetchData();
      },
    });
  };
  const hanleEditTabel = (record) => {
    editTabel(record);
  };

  const columns = [
    {
      title: '输出项名称',
      dataIndex: 'itemName',
      key: 'itemName',
      width: 150,
    },
    {
      title: '输出项类型',
      dataIndex: 'valueType',
      key: 'valueType',
      width: 150,
      render: (text) => (text === 'CONSTANT' ? '常量' : '变量'),
    },
    {
      title: '输出项',
      dataIndex: 'valueName',
      key: 'valueName',
      width: 200,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 200,
      render: (text) => (
        <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
      ),
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
      render: (text) => (
        <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
      ),
    },
    {
      title: '操作',
      render: (record) => {
        return (
          <div className={styles.handle_btn}>
            <ButtonML
              size="large"
              value="编辑"
              onClick={() => hanleEditTabel(record, 'edit')}
              disabled={String(editable) === 'false'}
            />
            {/* <Popconfirm
              title="是否确认删除"
              onConfirm={() => deleteRuleChange(record)}
              // onCancel={cancel}
              okText="确认"
              cancelText="取消"
            >
              <ButtonML
                size="large"
                value="删除"
                fontsize="14px"
                disabled={String(editable) === 'false'}
              />
            </Popconfirm>
            <div className={styles.handle_btn}> */}
            <ModalConfirmML
              title="是否确认删除?"
              handleOk={() => deleteRuleChange(record)}
              handleCancel={deleteTrigger.close}
              visible={deleteTrigger.visible}
              value="删除"
              icon={<ExclamationCircleOutlined />}
              disabled={String(editable) === 'false'}
            />
          </div>
        );
      },
      width: 120,
    },
  ];

  return (
    <Loading loading={delLoading} className="load_bor">
      <DataTable
        border={true}
        className="demo-test"
        style={{ border: '1px solid #edf0f0' }}
        columns={columns}
        rowSelection={false}
        scroll={{
          x: 1547,
          y: 'calc(50vh - 140px - 3rem)',
        }}
        dataSource={data}
        loading={loading}
        footer={() => (
          <ButtonML
            size="large"
            value="添加输出项"
            htmlType="submit"
            fontsize="16px"
            onClick={() => hanleEditTabel()}
            disabled={String(editable) === 'false'}
          />
        )}
      />
    </Loading>
  );
};
export default OutputTabel;
